import { IStepsList } from "../form/FormikStepper";
import FillingOrderForm from "./Forms/FillingOrderForm";
import { useIntl } from "react-intl";
import RankingOrderForm from "./Forms/RankingOrderForm";
import NetlinkingOrderForm from "./Forms/NetlinkingOrderForm";
import {
    Planning,
    UpsertBoostSchema,
    UpsertDiscoverSchema,
    UpsertFillingSchema,
    UpsertLeadSchema,
    UpsertNetlinkingSchema,
    UpsertRankingSchema,
} from "src/app/types/planning";
import { SimpleFormSelectOption } from "../form/SimpleFormSelect";
import BoostOrderForm from "./Forms/BoostOrderForm";
import DiscoverOrderForm from "./Forms/DiscoverOrderForm";
import LeadOrderForm from "./Forms/LeadOrderForm";

export const PlanningStepsList = (
    planning: Planning,
    thematicsOptions?: SimpleFormSelectOption[]
): { stepsList: IStepsList[]; maxSteps: number } => {
    0;
    const { formatMessage } = useIntl();
    const stepsList: IStepsList[] = [];
    if (planning?.orderType?.filling)
        stepsList.push({
            title: `${formatMessage({ id: "common.stepper.fillingKW" })}`,
            api: "filling",
            element: <FillingOrderForm planning={planning} />,
            validationSchema: UpsertFillingSchema(
                (planning.moneySite.content?.filling || 0) * planning.months
            ),
        });

    if (planning?.orderType?.lead)
        stepsList.push({
            title: `${formatMessage({ id: "common.stepper.leadKW" })}`,
            api: "lead",
            element: <LeadOrderForm planning={planning} />,
            validationSchema: UpsertLeadSchema(
                (planning.moneySite.content?.lead || 0) * planning.months
            ),
        });

    if (planning?.orderType?.boost)
        stepsList.push({
            title: `${formatMessage({ id: "common.stepper.boostKW" })}`,
            api: "boost",
            element: <BoostOrderForm planning={planning} />,
            validationSchema: UpsertBoostSchema(
                (planning.moneySite.content?.boost || 0) * planning.months
            ),
        });

    if (planning?.orderType?.discover)
        stepsList.push({
            title: `${formatMessage({ id: "common.stepper.discoverKW" })}`,
            api: "discover",
            element: <DiscoverOrderForm planning={planning} />,
            validationSchema: UpsertDiscoverSchema(
                (planning.moneySite.content?.discover || 0) * planning.months
            ),
        });

    if (planning?.orderType?.ranking)
        stepsList.push({
            title: `${formatMessage({ id: "common.stepper.rankingKW" })}`,
            api: "ranking",
            element: <RankingOrderForm planning={planning} />,
            validationSchema: UpsertRankingSchema(
                (planning.moneySite.content?.ranking || 0) * planning.months
            ),
        });

    if (planning?.orderType?.netlinking && thematicsOptions)
        stepsList.push({
            title: `${formatMessage({ id: "common.stepper.netlinkingKW" })}`,
            api: "netlinking",
            element: (
                <NetlinkingOrderForm planning={planning} thematicsOptions={thematicsOptions} />
            ),
            validationSchema: UpsertNetlinkingSchema,
        });

    /*  stepsList.push({
        title: `${formatMessage({ id: "common.stepper.silo" })}`,
        api: "silo",
        element: <></>,
        validationSchema: object({}),
    }); */

    return { stepsList, maxSteps: stepsList.length };
};
